import { message } from 'antd';

export const showSuccessToast = (msg) => {
  message.success(msg);
};

export const showErrorToast = (msg, timeout) => {
  message.error(msg, timeout);
};
